import { type Accessor, createMemo } from "/npm/solid-js@^1.9.5/+esm";
import { type ICustomElement } from "/npm/component-register@^0.8.7/+esm";

import { type ValidHybridPath } from "/npm/@brytdesigns/shopify-hybrid-cart-components@0.2.19/dist/jsdelivr/hooks/useFullPropertyPath.js";
import { useHybridCart } from "/npm/@brytdesigns/shopify-hybrid-cart-components@0.2.19/dist/jsdelivr/hooks/useHybridCart.js";
import { getValueFromPath } from "/npm/@brytdesigns/shopify-hybrid-cart-components@0.2.19/dist/jsdelivr/utils/index.js";

type Options = {
  path: Accessor<ValidHybridPath>;
  element: HTMLElement & ICustomElement;
};

export function useCartValue(options: Options) {
  const cart = useHybridCart(options.element);

  const value = createMemo(() => {
    const c = cart();
    if (typeof options.path !== "function") return c;
    const path = options.path();
    if (!path) return c;
    const v = getValueFromPath(c, path);
    if (v === undefined || v === null) return null;
    return v;
  });

  return value;
}
